import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next';

import { mainContext } from '../../../MainContext';
import FadeinWrap from '../../../../common/animation/FadeinWrap';


function ContainerPresent() {
  const { t } = useTranslation();


  useEffect(() => {
  }, [])


  return (
    <div className='margin-horizontal-auto mb-4'>
      <FadeinWrap>
        <img src={t('present')} className='object-fit-cover w-100 w-md-75' alt="ピアノ教室経営 指導法オンラインサロン" />
      </FadeinWrap>
    </div>
  );
}

export default ContainerPresent;